import React, { useEffect, useState } from "react";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import axios from "axios";
import dayjs from "dayjs";
import "../App.css";

import * as XLSX from "xlsx";
import { APIBaseURL } from "../Config";
import Swal from "sweetalert2";
import { formatToDateTime } from "./main/formatToDateTime";
import { Link } from "react-router-dom";

export default function ContainersHistory() {
  const [Data, setData] = useState([]);
  const [ModalData, setModalData] = useState("");

  const [containerNo, setContainerNo] = useState(null);
  const [in_from, setInFrom] = useState(null);
  const [out_from, setOutFrom] = useState(null);
  const [loading, setLoading] = useState(null);

  const handelForm = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formValues = Object.fromEntries(formData.entries());
    setContainerNo(formValues.containerNo);
    setInFrom(formValues.in_from);
    setOutFrom(formValues.out_from);
  };

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `${APIBaseURL}/get/yard/containers/history?page=${page}`;
    if (containerNo) {
      url += `&container_no=${containerNo}`;
    }
    if (in_from) {
      url += `&in_from=${in_from}`;
    }
    if (out_from) {
      url += `&out_from=${out_from}`;
    }

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
      } else {
        setData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const GetModalData = async (container_no, id) => {
    setLoading(true);
    let url = `${APIBaseURL}/get/yard/container/info/${container_no}?master_id=${id}`;
    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setModalData(response.data.data);
      } else {
        setModalData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [containerNo,in_from,out_from]);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row justify-content-between my-3">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="text-primary">Containers History</h4>
                      <form className="needs-validation" onSubmit={handelForm}>
                        <div className="row align-items-center">
                          <div className="col-md-3 mb-2">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                id="containerNo"
                                name="containerNo"
                              />
                              <label htmlFor="container-name">
                                Container Number
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3 mb-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="in_from"
                                id="in_from"
                                className="form-select"
                              >
                                <option value="">All</option>
                                <option value="GATE">GATE</option>
                                <option value="RAKE">RAKE</option>
                              </select>
                              <label htmlFor="in_from">In From</label>
                            </div>
                          </div>
                          <div className="col-md-3 mb-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="out_from"
                                id="out_from"
                                className="form-select"
                              >
                                <option value="">All</option>
                                <option value="GATE">GATE</option>
                                <option value="RAKE">RAKE</option>
                              </select>
                              <label htmlFor="out_from">Out From</label>
                            </div>
                          </div>
                          <div className="col-md-2 mb-2">
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                              onClick={() => window.location.reload()}
                            >
                              <i className="ri-restart-line ri-20px" />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <td>SN.</td>
                              <td>Container No.</td>
                              <td>Size</td>
                              {/* <td>Type</td> */}
                              <td>In From</td>
                              <td>In Time</td>
                              <td>Out From</td>
                              <td>Out Time</td>
                              {/* <td>Action</td> */}
                            </tr>
                          </thead>

                          {/* {Array.isArray(containersData) &&
                          containersData.length > 0 ? ( */}
                          <tbody>
                            {Data?.data?.map((container, i) => {
                              return (
                                <tr key={i} data-bs-toggle="modal"
                                data-bs-target="#ModalView"
                                onClick={() =>
                                  GetModalData(
                                    container.container_no,
                                    container.id
                                  )
                                }>
                                  <td >
                                    <span>{container.rn}</span>
                                  </td>
                                  <td>
                                    <span>{container.container_no}</span>
                                  </td>
                                  <td>
                                    <span>{container.container_size}</span>
                                  </td>
                                  {/* <td>
                                    <span>{container.type}</span>
                                  </td> */}
                                  <td>
                                    <span>{container.in_from}</span>
                                  </td>
                                  <td>
                                    <span>
                                      {formatToDateTime(container.in_time)}
                                    </span>
                                  </td>
                                  <td>
                                    <span>{container.out_from}</span>
                                  </td>
                                  <td>
                                    <span>
                                      {formatToDateTime(container.out_time)}
                                    </span>
                                  </td>
                                  {/* <td>
                                    <button
                                      className="btn btn-label-primary btn-sm mx-1"
                                      data-bs-toggle="modal"
                                      data-bs-target="#ModalView"
                                      onClick={() =>
                                        GetModalData(
                                          container.container_no,
                                          container.id
                                        )
                                      }
                                    >
                                      <i className="ri-eye-line ri-22px"></i>
                                    </button>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        {Data && Data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {Data.from} to {Data.to} of{" "}
                                  {Data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {Data &&
                                      Data.links &&
                                      Data.links.map((link, q) => {
                                        let showData =
                                          Data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                            ? "Previous"
                                            : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${
                                              link.active === true
                                                ? "active"
                                                : ""
                                            }  ${
                                              showData == "Next" &&
                                              Data.current_page ==
                                                Data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  Data.current_page == 1
                                                ? "disabled"
                                                : ""
                                            } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                      Data.current_page - 1
                                                    )
                                                  : showData == "Next"
                                                  ? GetData(
                                                      Data.current_page + 1
                                                    )
                                                  : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="ModalView"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Container Details
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setModalData("")}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table table-hover table-font table-striped">
                            <tbody>
                              <tr>
                                <th>Container No</th>
                                <td>{ModalData?.container_no}</td>
                              </tr>
                              <tr>
                                <th>Size</th>
                                <td>{ModalData?.container_size}</td>
                              </tr>
                              <tr>
                                <th>Type</th>
                                <td>{ModalData?.type}</td>
                              </tr>
                              <tr>
                                <th>In Time</th>
                                <td>{formatToDateTime(ModalData?.in_time)}</td>
                              </tr>
                            </tbody>
                          </table>

                          {ModalData?.in_gate_data && (
                            <>
                              <h5>Gate IN Data</h5>
                              <table className="table table-hover table-font table-striped">
                                <tbody>
                                  <tr>
                                    <th>Gate No</th>
                                    <td>{ModalData?.in_gate_data.gate_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Vehicle No</th>
                                    <td>
                                      {ModalData?.in_gate_data.vehicle_no}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Permit No</th>
                                    <td>{ModalData?.in_gate_data.permit_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Container Status</th>
                                    <td>
                                      {ModalData?.in_gate_data.containerstatus}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </>
                          )}

                          {ModalData.in_rake_data && (
                            <>
                              <h5>Rake In Data</h5>
                              <table className="table table-hover table-font table-striped">
                                <tbody>
                                  <tr>
                                    <th>Train No</th>
                                    <td>{ModalData?.in_rake_data.train_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Track</th>
                                    <td>{ModalData?.in_rake_data.track}</td>
                                  </tr>
                                  <tr>
                                    <th>Wagon No</th>
                                    <td>{ModalData?.in_rake_data.wagon_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Seal No</th>
                                    <td>{ModalData?.in_rake_data.seal_1_no}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </>
                          )}

                          <h5>Transactions</h5>
                          <div className="table-responsive">
                          <table className="table table-hover table-font table-striped">
                            <thead>
                              <tr>
                                <th>SN</th>
                                <th>Equipment</th>
                                <th>Stack</th>
                                <th>Source</th>
                                <th>Source Time</th>
                                <th>Destination</th>
                                <th>Dest Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {ModalData?.transactions?.map((txn, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{txn?.equipmentid}</td>
                                  <td>{txn?.unlockstackname??txn?.lockstackname}</td>
                                  <td>{txn?.locklocation}</td>
                                  <td>{formatToDateTime(txn?.lockdatetime)}</td>
                                  <td>{txn?.unlocklocation}</td>
                                  <td>
                                    {formatToDateTime(txn?.unlockdatetime)}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          </div>
                          {ModalData?.out_gate_data && (
                            <>
                              <h5>Gate Out Data</h5>
                              <table className="table table-hover table-font table-striped">
                                <tbody>
                                  <tr>
                                    <th>Gate No</th>
                                    <td>{ModalData?.out_gate_data.gate_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Vehicle No</th>
                                    <td>
                                      {ModalData?.out_gate_data.vehicle_no}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Permit No</th>
                                    <td>
                                      {ModalData?.out_gate_data.permit_no}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Container Status</th>
                                    <td>
                                      {ModalData?.out_gate_data.containerstatus}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Out Time</th>
                                    <td>
                                      {formatToDateTime(ModalData?.out_time)}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </>
                          )}

                          {ModalData.out_rake_data && (
                            <>
                              <h5>Rake Out Data</h5>
                              <table className="table table-hover table-font table-striped">
                                <tbody>
                                  <tr>
                                    <th>Train No</th>
                                    <td>
                                      {ModalData?.out_rake_data?.rake?.train_no}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Track</th>
                                    <td>
                                      {ModalData?.out_rake_data?.rake?.track}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Wagon No</th>
                                    <td>{ModalData?.out_rake_data.wagon_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Seal No</th>
                                    <td>
                                      {ModalData?.out_rake_data.seal_1_no}
                                      <br />
                                      {ModalData?.out_rake_data.seal_2_no}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Out Time</th>
                                    <td>
                                      {formatToDateTime(ModalData?.out_time)}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        onClick={() => setModalData("")}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
